import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import FJObjectEraseBrash from '../view/FJObjectEraseBrash';
import FJUtil from '../../../../util/FJUtil';
import PropTypes from 'prop-types';

const FJObjectEraseBrashContainer = ({ isShow }) => {
    const isNotImage = useSelector(state => state.objectErase.inputImageInfo === null);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const isDisabled = useMemo(() => {
        return FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;
    }, [taskStatus]);

    return <FJObjectEraseBrash isNotImage={isNotImage} disabled={isDisabled} taskStatus={taskStatus} isShow={isShow} />;
};

FJObjectEraseBrashContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJObjectEraseBrashContainer;
